import { FETCH_AUCTION, ADD_AUCTION, DELETE_AUCTION, DESTROY_AUCTION } from '../actionTypes';

export const addItem = payload => ({
    type: ADD_AUCTION,
    payload
});

export const fetchItem = auctions => ({
    type: FETCH_AUCTION,
    auctions
});

export const deleteItem = auction => ({
    type: DELETE_AUCTION,
    auction
});

export const destroyAuction = key => ({
    type: DESTROY_AUCTION,
    key
});